import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import './Login.css'
import Header from './Header'
import LockIcon from './LockIcon'
import Environment from './env_var'
import FooterPractice from './FooterPractice'
import ErrorHandling from './Error_Handling'
import DotSpinner from './Spinner'

const Logout = () => {
	const [data, setData] = useState(null)

	//const [checkingUserSession, setCheckingUserSession] = useState(true)
	const [isLoggedIn, setIsLoggedIn] = useState(false)
	const [navigateToLogin, setNavigateToLogin] = useState(false)

	const [requestingLogOut, setRequestingLogOut] = useState(false)
	const [successfulLogout, setSuccessfulLogout] = useState(false)

	const [error, setError] = useState(false)
	const [errorCode, setErrorCode] = useState(null)
	const [errorMessage, setErrorMessage] = useState(null)
	const [redirectType, setRedirectType] = useState(null)
	const [redirectURL, setRedirectURL] = useState(null)
	
	const fetchDomain = Environment.environment.env === 'production' ? Environment.environment.productionURL
	: Environment.environment.stagingURL

	const handleErrorAcknowledge = () => {
		//user not logged in send to login
		setNavigateToLogin(true)
	}

	const handleLogOutRequest = () => {
		setRequestingLogOut(true)
	}


	//send user's logout request
	useEffect(() => {
		if (requestingLogOut) {
			const headers = {
				'Content-Type': 'application/json', 
				credentials: 'include'
			}

			fetch(`${fetchDomain}/rlm/mobile-apis/logout_api.php`, {
				method: 'POST', 
				headers: headers
			})
			.then(response => response.json())
			.then(data => {
				if (data.httpResponse === 200) {
					setRequestingLogOut(false)
					setIsLoggedIn(false)
					setData(data)
					setSuccessfulLogout(true)
				} else {
					setRequestingLogOut(false)
					setError(true)
					setErrorCode(data.httpResponse)
					setErrorMessage(data.message)
					setRedirectURL(data.redirectURL)
					setRedirectType(data.redirectType)
				}
			})
			.catch((error) => {
				setError(true)
				setErrorCode(500)
				setErrorMessage(error)
			})
		}
	},[requestingLogOut])
	


	if (navigateToLogin) {
		//route user to appropriate launchpad
		return (
			<Navigate 
				to={{
					pathname: '/login',
				}}
				state={{
					isLoggedIn: false,
					loginError: errorCode === 403 ? true:false
				}}
			/>
		)
	} else if (requestingLogOut) {
		return (
			<React.Fragment>
				<Header isLoggedIn={isLoggedIn} />
					<DotSpinner />
				<FooterPractice view='launchpad' />
			</React.Fragment>
		)
	} else if (error) {
		return(
			<React.Fragment>
				<Header isLoggedIn={isLoggedIn} />
				<ErrorHandling
					error={error} 
					errorCode={errorCode} 
					errorMessage={errorMessage}
					redirectType={redirectType}
					redirectURL={redirectURL}
					requestingLogin={false}
					handleErrorAcknowledge={handleErrorAcknowledge}
				/>
				<FooterPractice view='launchpad' />
			</React.Fragment>
		)
	} else {
		//show logout
		return(
			<React.Fragment>
				{successfulLogout ? 
				<Navigate 
					to={{
						pathname: '/login',
					}}
					state={{
						isLoggedIn: false
					}} 
				/> : null}
				<Header isLoggedIn={true} />
				<div className='login-container' >
					<LockIcon width='54px' height='54px' fill='red' opacity='0.5' />
					<h1>Sign Out</h1>
					  <div className='form-container logout-button'>
					  	<button type='submit' name='submit' onClick={handleLogOutRequest} >Sign Out</button>
					  </div>
				</div>
				<FooterPractice view='launchpad' />
			</React.Fragment>
		)
	}
}

export default Logout
